





























import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import SAutocomplete from '@/components/UI/Form/Autocomplete/SAutocomplete.vue';
import { FetchPolicy } from 'apollo-client';

@Component
export default class SApolloAutocomplete<Item> extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public query!: any;
  @Prop({ type: Boolean, default: true }) public mustBeSelected!: boolean;
  @Prop({ type: Array, default: () => [] }) public initialData!: Item[];
  @Prop(Function) public variables!: (input: string, offset: number, limit: number) => object;
  @Prop({ type: Number, default: 300 }) public delay!: number;
  @Prop(Function) public unpackData!: (obj: object) => Item[];
  @Prop({ type: Number, default: 3 }) public minChars!: number;
  @Prop({ type: Number, default: 200 }) public limit!: number;
  @Prop({ type: String }) public fetchPolicy?: FetchPolicy;

  @Ref() public readonly autocompleteRef!: SAutocomplete<any, Item>; // eslint-disable-line @typescript-eslint/no-explicit-any

  public data: Item[] = [];
  public timeout?: NodeJS.Timeout;
  public isLoading = false;
  public showFeedback = true;

  public offset = 0;
  public reachedMaximum = false;

  public created() {
    this.data = this.initialData;
    this.reachedMaximum = this.data.length % this.limit > 0;
  }

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  public change(value: string) {
    this.offset = 0;
    this.reachedMaximum = false;
    if (value.length < this.minChars) return;
    if (this.timeout) clearInterval(this.timeout);
    this.timeout = setTimeout(this.fetchData.bind(this, value), this.delay);
    this.showFeedback = false;
  }

  public onScroll(value: string) {
    if (this.isLoading || this.reachedMaximum) return;
    this.offset += this.limit;
    const dataLength = this.data.length;
    this.fetchData(value).then(() => {
      this.reachedMaximum = this.data.length % this.limit > 0 || this.data.length === dataLength;
    });
  }

  public fetchData(value: string) {
    this.isLoading = true;
    return this.$apollo.query(
      {
        query: this.query,
        variables: this.variables(value, this.offset, this.limit),
        fetchPolicy: this.fetchPolicy,
      },
    ).then(({ data }: {data: object}) => {
      if (this.offset === 0) {
        this.data = this.unpackData(data);
      } else {
        this.data = this.data.concat(this.unpackData(data));
      }
    }).finally(() => {
      this.isLoading = false;
      this.showFeedback = true;
    });
  }

  @Emit('input')
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public selectedValue(value: any) {
    return value;
  }

  public focus() {
    this.autocompleteRef?.focus();
  }
}
